<template>
    <div>
        <div v-show='error_message != ""' class="error-message">
            {{ error_message }}
        </div>
        <div v-if='in_stock' class='buy-container'>
            <div class='quantity-container'>
                <input class='quantity-text-box' type="text" id="quantity" name="quantity" v-model='quantity' @blur='blurQuantity'>
                <div class='quantity-buttons-container'>
                    <div @click='incrementQuantity' class='change-quantity-button no-highlight'>+</div>
                    <div @click='decrementQuantity' class='change-quantity-button no-highlight'>-</div>
                </div>
            </div>
            <div v-if='in_stock' >
                <Button v-show='!product.locked_in' class='add-cart-button' text='Lock It In' theme='green' @click='addItemToCart'/>
                <Button v-show='product.locked_in' class='add-cart-button' text='Remove' theme='dark' @click='removeItemFromCart'/>
            </div>
        </div>
        <div class='successfully-added-to-bag-container'>
            <Tooltip :tooltip_queue='tooltip_queue'/>
        </div>
    </div>
</template>

<script>
import {checkAuth, fireCartEvent, fireOmetriaBasketEvent} from "@/global/modules/functions.js";

import Button from '@/ecom/components/buttons/Button.vue';
import NotifyWhenAvailableButton from '@/ecom/components/buttons/NotifyWhenAvailableButton.vue';
import ChangeQuantity from '@/ecom/components/cart/ChangeQuantity.vue';
import Tooltip from '@/ecom/components/popups/Tooltip.vue';

export default {
    components: {Button, ChangeQuantity, NotifyWhenAvailableButton, Tooltip},
    props: ['product', 'in_stock', 'item_quantity'],
    emits: ['updatedCartListener', 'removedFromCartListener', 'addToCartListener'],
    data(){
        return{
            quantity: this.item_quantity,
            tooltip_queue: [],
            is_disabled: false,
            cart_event: '',
            error_message: ''
        }
    },
    methods:{
        addItemToCart() {
            this.cart_event = 'add_item_to_cart';
            this.addToCart();
        },
        async addToCart(){
            this.error_message = '';
            if(Number(this.quantity) < 2) {
                this.error_message = "Minimum quantity must be 2";
                return;
            }

            let response = await fetch(`/api/lock-it-in/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    product: this.product,
                    quantity: this.quantity,
                    type: 'override_quantity'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(!results.stock.in_stock) {
                    let out_of_stock_message = '';
                    if(results.stock.left_in_stock > 0) {
                        out_of_stock_message = 'There are only ' + results.stock.left_in_stock  + ' of this item left in stock';
                    } else if(results.stock.left_in_stock == 0){
                        out_of_stock_message = 'This item is out of stock';
                    }
                    this.tooltip_queue.push({text: out_of_stock_message});
                    this.is_disabled = true;
                } else {
                    this.tooltip_queue.push({text: 'Added to bag!'});
                    this.triggerCartEvent();
                    fireOmetriaBasketEvent(results.cart, 'lock_it_in');
                }
                this.$emit('updatedCartListener');
                this.$emit('addToCartListener', this.product, this.quantity);
            }
        },
        async removeItemFromCart(){
            this.cart_event = 'remove_item_from_cart';
            let response = await fetch(`/api/lock-it-in/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   type: 'remove_item_from_cart'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.$emit('updatedCartListener');
                this.$emit('removedFromCartListener', this.product, this.quantity);
                this.triggerCartEvent();
                fireOmetriaBasketEvent(results.cart, 'lock_it_in');
            }
        },
        blurQuantity(){
            if(isNaN(this.quantity) || this.quantity == ''){
                this.quantity = 2;
            }

            this.error_message = '';
            if(Number(this.quantity) < 2) {
                this.error_message = "Minimum quantity must be 2";
                return;
            }

            if(this.product.locked_in){
                this.cart_event = 'blur_quantity';
                this.addToCart();
            }
        },
        incrementQuantity(){
            this.quantity++;

            if(this.product.locked_in){
                this.cart_event = 'increment_quantity';
                this.addToCart();
            }
        },
        decrementQuantity(){
            if(this.quantity > 2){
                this.quantity--;
            }

            if(this.product.locked_in){
                this.cart_event = 'decrement_quantity';
                this.addToCart();
            }
        },
        triggerCartEvent() {
            let change_quantity = (this.cart_event == 'increment_quantity' || this.cart_event == 'decrement_quantity') ? 1 : this.quantity;
            let event_name      = (this.cart_event == 'decrement_quantity' || this.cart_event == 'remove_item_from_cart') ? 'remove_from_cart' : 'add_to_cart';
            fireCartEvent(this.product, change_quantity, event_name, 'lock-it-in');
        }
    },
    watch: {
        'item_quantity' : function() {
            this.quantity = this.item_quantity;
        }
    }
}
</script>

<style lang="scss" scoped>
.buy-container{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;
    text-align: center;
    justify-content: center;
}

.successfully-added-to-bag-container{
    display: flex;
    justify-content: center;
}
.add-cart-button{
    width: 200px;
}

.quantity-container{
    display: flex;
    //justify-content: center;
}

.change-quantity-button no-highlight {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
 
.change-quantity-button{
    border: 1px solid #dee2e6;
    height: 19px;
    width: 19px;
    cursor: pointer;
}

.minus-button{
    border-radius: 4px 0px 0px 4px;
}

.plus-button{
    border-radius: 0px 4px 4px 0px;
}

.quantity-text-box{
    width: 40px;
    height: 38px;
    text-align: center;
    border-top: solid 1px #dee2e6;
    border-left: none;
    border-right: none;
    border: 1px solid #dee2e6;
    outline: none;
}

.quantity-text-box:focus{
     outline: none;
}

.out-of-stock-container{
    position: absolute;
    margin-top: 40px;
}
.error-message {
    color: #e03131;
    font-size: 0.85rem;
    text-align: center;
    margin-right: 48px;
    margin-bottom: 5px;
}
</style>